<template>
  <input
    :id="elementId"
    v-model="proxyChecked"
    type="checkbox"
    :value="trueValue"
    class="hidden peer"
    :disabled="disabled"
    @click.stop=""
  >
</template>

<script setup>
import { computed, toRefs } from 'vue'
import { useProp } from '@/composables/useProp.js'
import { id } from 'random-html-id'

const emit = defineEmits(['update:modelValue'])

const props = defineProps({
  modelValue: useProp(Array),
  trueValue: useProp(Number, 1),
  label: useProp(String),
  disabled: useProp(Boolean),
  hidden: useProp(Boolean),
  peer: useProp(Boolean)
})

const { modelValue } = toRefs(props)

const elementId = computed(() => 'stormy-checkbox-' + id(8))

const proxyChecked = computed({
  get () {
    return modelValue.value.includes(props.trueValue)
  },
  set (newValue) {
    let values = []
    for (const value of modelValue.value) {
      values.push(value)
    }
    if (newValue) {
      values.push(props.trueValue)
    } else {
      values = values.filter(item => item !== props.trueValue)
    }

    emit('update:modelValue', values)
  }
})

</script>
